
import axios from 'axios';
import _ from 'lodash';
import React, { Component } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

import qs from 'qs';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const StyledAutocomplete = styled(Autocomplete)`
  .MuiTextField-root {
    margin-bottom: 0;
  }
`;


export class AsyncAutocompleteWidget2 extends Component {

  static defaultProps = {
    optionLabel: 'name',
    optionId: 'id',
    emptyValue: null,
    preloadOptions: true,
    disableClearable: false
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null,
      options: [],
      filter: {},
      loading: false,
      isOpen: false,
      isOpenEditDialog: false
    }
  }

  handleChange = (e, newValue) => {
    const { onChange, emptyValue } = this.props;
    this.setState({
      selectedOption: newValue
    });
    onChange(newValue ? newValue.id : emptyValue, newValue);
  };

  handleOptionSelected = (option, value) => {
    if (value) {
      return option.id === value.id;
    }
    return false;
  };

  getOptionLabel = (option) => {
    const { optionLabel } = this.props;
    if (_.isObject(option))
      return option[optionLabel];
  };

  getOptionId = (option) => {
    const { optionId } = this.props;
    return option[optionId];
  };

  loadSelectedOption = (value) => {
    const { url } = this.props;
    if (value) {
      let valueId = _.isObject(value) ? this.getOptionId(value) : value;

      this.setState({
        loading: true
      });

      axios.get(`${url}/${valueId}`).then(res => {
        const option = res.data;
        this.setState({
          options: [option],
          selectedOption: option,
          loading: false
        })
      });
    }
  };

  findOption = (value) => {
    const { options } = this.state;
    let valueId = _.isObject(value) ? this.getOptionId(value) : value;
    return _.find(options, {id: valueId});
  };

  componentDidMount() {
    const { value, preloadOptions } = this.props;
    if (value) {
      this.loadSelectedOption(value);
    }
    else if (preloadOptions) {
      this.loadOptions();
    }
  }

  handleAddOption = (option) => {
    let { options } = this.state;
    options.unshift(option);
    setTimeout(() => {
      this.handleChange(null, option);
    }, 100);
  };

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps, nextContext) {
    if (!nextProps.value) {
      this.setState({
        selectedOption: null
      })
    }
    else if (_.isNumber(nextProps.value)) {
      const option = this.findOption(nextProps.value);
      if (option) {
        this.setState({
          selectedOption: option
        })
      }
      else {
        this.loadSelectedOption(nextProps.value);
      }
    }
    else if (_.isObject(nextProps.value)) {
      const option = nextProps.value;
      const optionExists = this.findOption(nextProps.value);
      if (!optionExists) {
        let options = this.state.options;
        options.unshift(option);
        this.setState({
          options: options,
          selectedOption: option
        })
      }
      else {
        this.setState({
          selectedOption: option
        })
      }
    }
  }

  loadOptions = async (otherFilter) => {
    const { filter, url } = this.props;

    let options = [];
    this.setState({
      loading: true
    });

    const load = async () => {
      return axios.get(url, {
        params: {...filter, ...otherFilter},
        paramsSerializer: function (params) {
          return qs.stringify(params, {arrayFormat: 'repeat'})
        },
      }).then(res => {
        const data = res.data;
        if (data && data.results) {
          options = data.results;
        }
      });
    };

    await load();

    this.setState({
      loading: false,
      options: options
    });
  };

  handleInputChange = (e, value, reason) => {
    if (reason === 'input') {
      this.loadOptions({q: value});
    }
  };

  handleClose = () => {
    this.setState({
      isOpen: false
    })
  };

  handleOpen = () => {
    this.setState({
      isOpen: true
    })
  };

  toggleIsOpenEditDialog = () => {
    this.setState({
      isOpenEditDialog: !this.state.isOpenEditDialog
    })
  }

  render() {
    const { label, placeholder, size, dialogTitle, disabled, disableClearable, DialogComponent, EditDialogComponent, dialogProps } = this.props;
    const { options, loading, selectedOption, isOpen, isOpenEditDialog } = this.state;

    return (
      <>
        <StyledAutocomplete
          options={options}
          loading={loading}
          value={selectedOption}
          getOptionSelected={this.handleOptionSelected}
          getOptionLabel={(option) => this.getOptionLabel(option)}
          onInputChange={(e, value, reason) => this.handleInputChange(e, value, reason)}
          size={size}
          filterOptions={(options, state) => options}
          onChange={(e, newValue) => this.handleChange(e, newValue)}
          disabled={disabled}
          disableClearable={disableClearable}
          renderInput={(params) => {
            params.InputProps['endAdornment'] =
              <>
                {params.InputProps['endAdornment']}
                {(selectedOption === null && DialogComponent) && (
                  <InputAdornment position="end">
                    <IconButton size={'small'} onClick={() => this.handleOpen()}>
                      <AddOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                )}
                {(selectedOption !== null && EditDialogComponent) && (
                  <InputAdornment position="end">
                    <IconButton size={'small'} onClick={() => this.toggleIsOpenEditDialog()}>
                      <EditOutlinedIcon style={{fontSize: '1.25rem'}} />
                    </IconButton>
                  </InputAdornment>
                )}
              </>;
            return (
              <TextField
                {...params}
                variant="outlined"
                label={label}
                placeholder={placeholder}
              />
            )
          }}
        />
        {(selectedOption === null && DialogComponent) && (
          <Dialog
            open={isOpen}
            onClose={() => this.handleClose()}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            {...dialogProps}
          >
            <DialogTitle id="scroll-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent dividers={true}>
              {isOpen && (
                <DialogComponent
                  onClose={this.handleClose}
                  onAddOption={(option) => this.handleAddOption(option)}
                />
              )}
            </DialogContent>
          </Dialog>
        )}
        {(selectedOption !== null && EditDialogComponent) && (
          <Dialog
            open={isOpenEditDialog}
            onClose={() => this.toggleIsOpenEditDialog()}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            {...dialogProps}
          >
            <DialogTitle id="scroll-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent dividers={true}>
              {isOpenEditDialog && (
                <EditDialogComponent
                  onClose={this.toggleIsOpenEditDialog}
                  item={selectedOption}
                />
              )}
            </DialogContent>
          </Dialog>
        )}
      </>
    )
  }
}